import IconComponent from "icons/IconComponent";

import ArrowDownIcon from "./arrowDown.svg";

export default (ArrowDownIcon as any) as IconComponent;
